<div class="cm-skeleton-stat-tiles">
  @for (tile of [].constructor(tileCount()); track $index) {
    <div class="cm-skeleton-stat-tile">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 50%;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 60%; height: 2rem; border-radius: 4px;"></div>
    </div>
  }
</div>
